/**
 * The footer the door and both sign-in steps carry: the website's privacy and terms pages, on a
 * hairline, each link a box at least 48px each way so a thumb finds it. The hairline runs the whole
 * width, and the links are in the page's one column (`column.ts`), so at a desk they line up with
 * the page.
 */
import { PRIVACY_HREF, TERMS_HREF } from '../contact.ts';
import { COLUMN } from './column.ts';

/** A link to one of the website's pages, a box at least 48px each way; Account's Help has them. */
export const FOOTER_LINK =
  'inline-flex min-h-tap min-w-tap items-center justify-center text-body text-text-brand ' +
  'underline underline-offset-4 hover:text-text-body';

export function Footer() {
  return (
    <footer className="border-t border-border-subtle">
      <ul className={`${COLUMN} flex flex-wrap gap-x-6 px-5 py-2`}>
        <li>
          <a href={PRIVACY_HREF} className={FOOTER_LINK}>
            Privacy
          </a>
        </li>
        <li>
          <a href={TERMS_HREF} className={FOOTER_LINK}>
            Terms
          </a>
        </li>
      </ul>
    </footer>
  );
}
